import { defineComponent } from 'vue';
import Bscroll from '@better-scroll/core';
export default defineComponent({
    props: {
        list: {
            type: Array,
            default() {
                return [];
            }
        },
        diseaseId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            bs: null
        };
    },
    watch: {
        list(newData) {
            if (!newData.lenght) {
                return;
            }
            this.$nextTick(() => {
                if (this.bs) {
                    this.bs.refresh();
                }
                else {
                    this.bs = new Bscroll(this.$refs.scrollBox, {
                        scrollX: false,
                        scrollY: true,
                        click: true
                    });
                }
            });
        }
    },
    methods: {
        checkDisease(id) {
            this.$emit('checkDisease', id);
        }
    }
});
